<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div style="overflow-x: auto">
      <table aria-label="Tableau affichant les animaux en attente de validation"
             class="table table-bordered table-striped table-border-purple table-head-purple bg-white">
        <thead class="thead-default">
        <tr>
          <th class="text-center" i18n="@@quantity" scope="col">Quantity</th>
          <th class="text-center" i18n="@@animalSpecies" scope="col">Species</th>
          <th class="text-center" i18n="@@animalCategory" scope="col">Category</th>
          <th class="text-center" i18n="@@weight" scope="col">Weight</th>
          <th *ngIf="showNumberCountry" class="text-center" i18n="@@country" scope="col">Country</th>
          <th *ngIf="showNumberCountry" class="text-center" i18n="@@animalNumber" scope="col">Number</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let d of data">
          <td class="text-center">{{ d?.quantity }}</td>
          <td class="text-center">{{ d?._embedded?.animalSpecies?.tag }}</td>
          <td class="text-center">{{ d?._embedded?.animalCategory?.tag }}</td>
          <td class="text-center">{{ d?.weightE }} kg</td>
          <td class="text-center" *ngIf="showNumberCountry">{{ d?._embedded?.country?.alpha2 }}</td>
          <td class="text-center" *ngIf="showNumberCountry">{{ d?.number }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
